<template>
  <td>
    <table>
      <tr>
        <td style="text-align: left;">{{ number }}</td>
      </tr>
      <tr>
        <td style="text-align: center;">
          <table class="shipmentPalletPosition">
            <tr>
              <td :class="delivery.positions[this.positionIndex] ? 'selected' : isInUse ? 'inUse' : ''" :style="delivery.halfPallet ? 'height: 20px;' : 'height: 58px;'" @click="togglePosition(delivery)">&nbsp;</td>
            </tr>
            <tr v-if="delivery.halfPallet">
              <td :class="delivery.positions[this.positionIndexSecondRow] ? 'selected' : isInUseSecondRow ? 'inUse' : ''" style="height: 20px;" @click="togglePositionSecondRow(delivery)">&nbsp;</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </td>
</template>

<script>

export default {
  name: 'ShipmentPalletPosition',
  components: { },
  props: {
    value: Object,
    position: String,
    inUse: Array,
    disabled: Boolean
  },
  created: function () {
    // console.log('Create ShipmentPalletPosition')
    this.delivery = this.value
  },
  data () {
    return {
      delivery: {}
    }
  },
  methods: {
    togglePosition (delivery) {
      if (!this.disabled) {
        let newValue = !delivery.positions[this.positionIndex]
        if (!newValue || this.numberOfPositions(delivery) < Math.ceil(delivery.numberOfPallets)) {
          // console.log('Set position ' + this.positionIndex + ' to ' + newValue)
          this.$set(delivery.positions, this.positionIndex, newValue)
        }
      }
    },
    togglePositionSecondRow (delivery) {
      if (!this.disabled) {
        let newValue = !delivery.positions[this.positionIndexSecondRow]
        if (!newValue || this.numberOfPositions(delivery) < Math.ceil(delivery.numberOfPallets)) {
          // console.log('Set position ' + this.positionIndexSecondRow + ' to ' + newValue)
          this.$set(delivery.positions, this.positionIndexSecondRow, newValue)
        }
      }
    },
    numberOfPositions (delivery) {
      let count = 0
      for (let pos of delivery.positions) {
        if (pos) {
          count++
        }
      }
      return count
    }
  },
  computed: {
    positionIndex: function () {
      return Number(this.position) - 1
    },
    positionIndexSecondRow: function () {
      return Number(this.position) - 1 + 10
    },
    number: function () {
      return Number(this.position)
    },
    numberSecondRow: function () {
      return this.number + 10
    },
    isInUse: function () {
      return this.inUse && (this.inUse.includes(Number(this.position)) || (!this.delivery.halfPallet && this.inUse.includes(Number(this.position) + 10)))
    },
    isInUseSecondRow: function () {
      return this.inUse && this.inUse.includes(Number(this.position) + 10)
    }
  }
}
</script>

<style scoped>
  table.shipmentPalletPosition {
    border-spacing: 2px;
    border-collapse: separate;
    padding: 0;
  }
  table.shipmentPalletPosition tr td {
    padding: 5px;
    width: 100px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    cursor: pointer;
  }
  .shipmentPalletPosition tr td.selected {
    color: white;
    background-color: rgba(0, 77, 64, 0.8);
    border: 1px solid rgba(0, 77, 64, 0.8);
  }
  .shipmentPalletPosition tr td.inUse {
    background-color: #ccd0cc;
    border: 1px solid #ccd0cc;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipmentPalletPosition.vue